<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Order Summary
      </div>
    </div>
    <v-divider class="mt-1 mb-4 mr-2"></v-divider>
    <v-card class="pl-0">
      <v-card-title class="card-title"
        >Summary
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_infor:b2b_inbound_asn_grr_closure_generate') &&
            summaryData.receipt_status == 'Closed'
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon medium class="mr-2 pl-4" v-on="on" @click="downloadASN()">
              mdi-receipt
            </v-icon>
          </template>
          <span>Goods Received Download</span> </v-tooltip
        ><v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="pl-0">
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Order Details </b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">ASN/Receipt</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.receipt_key }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0 text-medium-emphasis">Receipt No</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.receipt_no }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Created At</div>
                <div class="text-left col-md-7 p-0" v-if="summaryData.adddate">
                  {{
                    summaryData.adddate
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Arrival Date</div>
                <div
                  class="text-left col-md-7 p-0"
                  v-if="summaryData.arrivaldatetime"
                >
                  {{
                    summaryData.arrivaldatetime
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">BOE</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.boe }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Storer</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.storer_key }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Type</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.type }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Carrier Code</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.carrier_code }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Carrier Reference</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.carrierreference }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Vendor Reference</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.vendorreference }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Warehouse Reference</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.warehousereference }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-5 p-0">Trailer Number</div>
                <div class="text-left col-md-7 p-0">
                  {{ summaryData.trailernumber }}
                </div>
              </div>
            </v-col>
          </v-col>
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Order Details </b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Expected Cube</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.expected_cube }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Expected Weight</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.expected_weight }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Received Cube</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.received_cube }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Received Weight</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.received_weight }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Total Expected Qty</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.total_expected_qty }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Total Received Qty</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.total_received_qty }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Earliest Delivery Date</div>
                <div
                  class="text-left col-md-6 p-0"
                  v-if="summaryData.earliestdeliverydate"
                >
                  {{
                    summaryData.earliestdeliverydate
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Expected Receipt Date</div>
                <div class="text-left col-md-6 p-0">
                  {{
                    summaryData.expectedreceiptdate
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Closed Date</div>
                <div
                  class="text-left col-md-6 p-0"
                  v-if="summaryData.closeddate"
                >
                  {{
                    summaryData.closeddate
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Verified Closed Date</div>
                <div
                  class="text-left col-md-6 p-0"
                  v-if="summaryData.verifiedcloseddate"
                >
                  {{
                    summaryData.verifiedcloseddate
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Status</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.receipt_status }}
                </div>
              </div>
            </v-col>
          </v-col>
          <v-col cols="4">
            <v-col cols="12" class="pl-0">
              <div>
                <b>Supplier Details </b>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0 text-medium-emphasis">
                  Supplier Name
                </div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.suppliername }}
                </div>
              </div>

              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Supplier Code</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.suppliercode }}
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="pl-0">
              <div><b>Container Details</b></div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0 text-medium-emphasis">
                  Container Key
                </div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.containerkey }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Container Qty</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.containerqty }}
                </div>
              </div>
              <div class="col-md-12 d-flex p-0 m-0">
                <div class="col-md-6 p-0">Container Type</div>
                <div class="text-left col-md-6 p-0">
                  {{ summaryData.containertype }}
                </div>
              </div>
            </v-col>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row>
          <v-col class="pl-0">
            <v-data-table
              :headers="itemheaders"
              :items="orderDetails"
              :loading="inboundOrderLoader"
              disable-pagination
              :hide-default-footer="true"
              class="custom-class"
            >
              <template v-slot:[`item.created_at`]="{ item }">
                <span v-if="item.created_at">{{
                  item.created_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.updated_at`]="{ item }">
                <span v-if="item.updated_at">{{
                  item.updated_at | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.receiving_date`]="{ item }">
                <span v-if="item.receiving_date">{{
                  item.receiving_date
                    | uaeDateTime
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.mfg_date`]="{ item }">
                <span v-if="item.mfg_date">{{
                  item.mfg_date | uaeDateTime | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.expiry_date`]="{ item }">
                <span v-if="item.expiry_date">{{
                  item.expiry_date
                    | uaeDateTime
                    | moment("DD MMM, YYYY hh:mm A")
                }}</span>
              </template>
              <template v-slot:[`item.item_sku`]="{ item }">
                <label>
                  {{ item.item_sku }}
                </label>
              </template>
              <template v-slot:[`item.unit_price`]="{ item }">
                <label>
                  {{ item.unit_price }}
                  <span v-if="item.currency">({{ item.currency }})</span>
                </label>
              </template>
              <template v-slot:[`item.expected_qty`]="{ item }">
                <label>
                  {{ changeNumberFormat(item.expected_qty) }}
                </label>
              </template>
              <template v-slot:[`item.received_qty`]="{ item }">
                <label>
                  {{ changeNumberFormat(item.received_qty) }}
                </label>
              </template>
              <template v-slot:[`item.description`]="{ item }"
                >{{ findDescription(item.sku, "description") }}
              </template>
              <template v-slot:[`item.tier`]="{ item }"
                >{{ findDescription(item.sku, "tier") }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
  },
  data: () => ({
    inboundOrderLoader: false,

    options: {},
    total: 0,
    summary: false,
    order_number: null,
    filtersArr: {},
    clients: [],
    summaryData: {},
    itemheaders: [
      {
        text: "SKU",
        value: "sku",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Description",
        value: "description",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "External line No",
        value: "externlineno",
        sortable: false,
        class: "body-1 font-weight-bold",
      },
      {
        text: "Line",
        value: "line",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pack",
        value: "pack",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "UOM",
        class: "body-1 font-weight-bold",
        value: "uom",
        sortable: false,
      },
      {
        text: "Hold Code",
        value: "hold_code",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "LPN",
        class: "body-1 font-weight-bold",
        value: "lpn",
        sortable: false,
      },
      {
        text: "Location",
        class: "body-1 font-weight-bold",
        value: "location",
        sortable: false,
      },
      {
        text: "Origin Country",
        class: "body-1 font-weight-bold",
        value: "country_of_origin",
        sortable: false,
      },

      {
        text: "Expected Qty",
        class: "body-1 font-weight-bold",
        value: "expected_qty",
        sortable: false,
      },

      {
        text: "Received Qty",
        class: "body-1 font-weight-bold",
        value: "received_qty",
        sortable: false,
      },

      {
        text: "Unit Price",
        class: "body-1 font-weight-bold",
        value: "unit_price",
        sortable: false,
      },
      {
        text: "Receiving Date",
        class: "body-1 font-weight-bold",
        value: "receiving_date",
        sortable: false,
      },
      {
        text: "Manufacturing Date",
        value: "mfg_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Expiry Date",
        value: "expiry_date",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable06",
        value: "lottable06",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable07",
        value: "lottable07",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable08",
        value: "lottable08",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable09",
        value: "lottable09",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "lottable10",
        value: "lottable10",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Tier",
        value: "tier",
        class: "body-1 font-weight-bold",
        align: "left",
        width: 120,
        sortable: false,
      },
      {
        text: "Status",
        class: "body-1 font-weight-bold",
        value: "status",
        sortable: false,
      },
      {
        text: "Created At",
        class: "body-1 font-weight-bold",
        value: "created_at",
        sortable: false,
      },

      {
        text: "Updated At",
        class: "body-1 font-weight-bold",
        value: "updated_at",
        sortable: false,
      },
    ],
    orderDetails: [],
    statuses: [],
    allocatesStatus: [{ text: "Yes", value: "yes" }],
    allocated: "",
    status: "",
    selectedItem: {},
  }),

  watch: {
    options: {
      handler() {},
      deep: true,
    },
  },
  created() {
    this.inboundOrderLoader = true;

    let payload = {
      id: this.$route.query.id,
      request_type: "inbound",
    };
    this.inboundorderSummary({ ...payload })
      .then((res) => {
        this.inboundOrderLoader = false;
        this.orderDetails = res.data.data.items;
        this.summaryData = res.data.data;
      })
      .catch(() => {
        this.inboundOrderLoader = false;
      });
  },

  methods: {
    ...mapActions(["inboundorderSummary", "downloadInboundASN"]),
    findDescription(id, type) {
      if (type == "description") {
        return this.summaryData.description[id].description;
      } else {
        return this.summaryData.description[id].tier;
      }
    },
    downloadASN() {
      this.downloadInboundASN(this.$route.query.id)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 0px 5px 5px !important;
}
.p-0 {
  padding: 0px !important;
}
</style>
-
